import { useContext } from 'react';

import { PageId } from '../../apis';
import { PageViewContext } from '../../contexts/PageViewContext';

export function usePageView(): {
  pageId: PageId | null;
  pageViewId: string | null;
} {
  return useContext(PageViewContext);
}
